<template>
  <div>
    <ThreadsNav :show-center="false" show-back></ThreadsNav>
    <div class="px-3">
      <h3 class="text-2xl font-semibold">{{ $t(`Payment.bindPaypal`) }}</h3>

      <input
        v-model="account"
        :placeholder="$t(`Payment.inputPaypalAccount`)"
        class="w-full bg-my-dark h-12 px-2.5 my-4"
        type="text"
      />

      <input
        v-model="accountConfirm"
        :placeholder="$t(`Payment.confirmPaypalAccount`)"
        class="w-full bg-my-dark h-12 px-2.5"
        type="text"
      />

      <div class="flex flex-col items-center mt-10">
        <button
          class="btn btn-primary btn-sm mb-3 min-w-[120px]"
          @click="clickBind"
        >
          {{ $t(`Buttons.bind`) }}
        </button>
        <button
          class="btn btn-primary btn-sm min-w-[120px]"
          @click="router.back"
        >
          {{ $t(`Buttons.back`) }}
        </button>

        <img
          alt=""
          class="w-[114px] mt-[140px]"
          src="@/assets/img/paypal.png"
        />
        <p class="text-my-gray mt-2.5" v-html="$t(`Payment.notHasPaypal`)"></p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { showFailToast, showLoadingToast } from "vant";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const account = ref("");
const accountConfirm = ref("");
const userStore = useGlobalUser();
const { t } = useI18n();
const router = useRouter();

const clickBind = async () => {
  if (account.value !== accountConfirm.value)
    return showFailToast(t(`Payment.accountNotMatch`));

  const loading = showLoadingToast({ message: t(`Message.loading`) });
  try {
    userStore.updateUserApi({ paypal: account.value });
    loading.close();
    router.replace({ name: "withdrawal" });
  } catch (e) {
    loading.close();
  }
};
</script>
